import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth.module';
import base from './base.module';
import meters from './servorgs/meters.module';
import users from './users.module';
import permissions from './permissions.module';
import uploads from './servorgs/uploads.module';
import reports from './reports.module';
import health from './health.module';
import ksk from './ksk.module';
import request from './request.module';
import ahsRequests from './ahs-requests.module';
import documents from './documents.module';
import prescription from './prescription.module';
import prescription_ozp from './prescription_ozp.module';
import contracts from './contracts.module';
import accounts from './accounts.module';
import refs from './refs.module';
import loader from './loader.module';
import sign from './sign.module';
import acts from './acts.module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        base,
        meters,
        users,
        permissions,
        uploads,
        reports,
        health,
        ksk,
        request,
        ahsRequests,
        documents,
        prescription,
        prescription_ozp,
        contracts,
        accounts,
        refs,
        loader,
        sign,
        acts
    }
});
